import Modal from 'shared/Modal';
import { AddServiceToRealmForm } from './AddServiceToRealmForm';
import { Realm } from 'types';

export const AddServiceToRealmModal = ({
  onClose,
  realmId,
}: {
  onClose: VoidFunction;
  realmId: Realm['realm_id'];
}) => {
  return (
    <Modal open onClose={onClose} modalHeight={600}>
      <AddServiceToRealmForm disableSelectTenantAndRealm realmId={realmId} />
    </Modal>
  );
};
